export default __webpack_public_path__ + "static/media/03.cb819742.webp";